import { AnnouncementCategoryGroup } from "../models/announcement/announcement-category-group";
import { AnnouncementCategoryGroupRequest } from "../models/announcement/announcement-category-request";
import { AnnouncementRequest } from "../models/announcement/announcement-request";
import { TrafficActionRequest } from "../models/traffic-action/traffic-action-request";
import { TrafficAction } from "../models/traffic-action/traffic-action";
import { Announcement } from "../models/announcement/announcement";
import { UpdateTrafficActionTrainsRequest } from "../models/traffic-action/update-traffic-action-trains";
import { Filter } from "../models/event/filter";
import { Train } from "../models/train";
import { GenerateActionRequest } from "../models/traffic-action/generate-traffic-action-request";

export function buildGenerateTrafficActionRequest(
  trafficAction: TrafficAction
): GenerateActionRequest {
  return {
    eventId: trafficAction.eventId,
    reasonId: trafficAction.reasonId,
    templateType: trafficAction.templateType,
    affectedTrains: trafficAction.filterGeneratedTrains?.map(
      (t) => t.trainNumber
    ),
    filter: trafficAction.filter,
  };
}

export function buildTrafficActionRequest(
  trafficAction: TrafficAction
): TrafficActionRequest {
  return {
    id: trafficAction.id,
    eventId: trafficAction.eventId,
    templateType: trafficAction.templateType,
    reasonId: trafficAction.reasonId,
    trainNumbers: trafficAction.filterGeneratedTrains ?? trafficAction.trains,
    reminderInMinutes: trafficAction.reminderInMinutes,
    announcementCategoryGroups: buildAnnouncementCategoryGroupRequest(
      trafficAction.announcementCategoryGroups,
      trafficAction.filter,
      trafficAction.filterGeneratedTrains ?? trafficAction.trains
    ),
    filter: trafficAction.filter,
  };
}

export function buildUpdateTrafficActionTrainsRequest(
  trafficAction: TrafficAction
): UpdateTrafficActionTrainsRequest {
  return {
    id: trafficAction.id,
    eventId: trafficAction.eventId ?? 0,
    templateType: trafficAction.templateType,
    reasonId: trafficAction.reasonId,
    reminderInMinutes: trafficAction.reminderInMinutes,
    announcementCategoryGroups: buildAnnouncementCategoryGroupRequest(
      trafficAction.announcementCategoryGroups,
      trafficAction.filter,
      trafficAction.filterGeneratedTrains
    ),
    filter: trafficAction.filter,
  };
}

export function buildAnnouncementRequest(
  a: Announcement,
  _actionFilter: Filter,
  _filterGeneratedTrains: Train[]
): AnnouncementRequest {
  return {
    id: a.id,
    active: a.active,
    split: a.split,
    priority: a.priority,
    arrivals: a.arrivals,
    departures: a.departures,
    firstLast: a.firstLast,
    refId: a.refId,
    trainNumbers: a.filterGeneratedTrains ?? a.trainNumbers,
    categoryText: a.categoryText,
    announcementActivityIds: a.announcementActivityIds,
    filter: a.filter,
    onlyInTrv: a.onlyInTrv,
    title: a.title,
    toBeDeleted: a.toBeDeleted,
    tempId: a.tempId,
    status: a.status,
    state: a.state,
    splitFromId: a.splitFromId,
    overrideViaStationValidation: a.overrideViaStationValidation,
  };
}

export function buildAnnouncementCategoryGroupRequest(
  announcementCategoryGroups: AnnouncementCategoryGroup[],
  actionFilter: Filter,
  filterGeneratedTrains: Train[]
): AnnouncementCategoryGroupRequest[] {
  return announcementCategoryGroups.map((acg) => ({
    id: acg.id,
    categoryType: acg.categoryType,
    announcements: buildAnnouncementRequests(
      acg.announcements,
      actionFilter,
      filterGeneratedTrains
    ),
  }));
}

export function buildAnnouncementRequests(
  announcements: Announcement[],
  actionFilter: Filter,
  filterGeneratedTrains: Train[]
): AnnouncementRequest[] {
  return announcements.map((a) =>
    buildAnnouncementRequest(a, actionFilter, filterGeneratedTrains)
  );
}
